export default "__VITE_ASSET__wFKW7XXp__"